import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {customAxios} from "../functions/custom_axios";



const name = 'inquiries';
const entity = 'inquiry';
//const entities = 'inquiries';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });



export const inquiriesActions = { ...slice.actions, ...extraActions };
export const inquiriesReducer = slice.reducer;



function createInitialState() {
    return {
        list: null,
        item: null,
        inquiries: null,
        communicationMode:null,
        inquiryTypes: null,
        listAPIResponse: null
    }
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}`;

    return {
        getNewEntity: getNewEntity(),
        create: create(),
        getAllCommunicationModes: getAllCommunicationModes(),
        getAllInquiryTypes: getAllInquiryTypes(),
    };

    function getNewEntity() {
        return createAsyncThunk(
            `${name}/getNewEntity`,
            async function (entity, { getState }) {
                //alert('entity: '+JSON.stringify(entity));
                    return entity;
            }
        );
    }

    function create() {
        return createAsyncThunk(
            `${name}/create`,
            async function ({ data }, { getState }) {
                try {
                    const token = getState().auth.value;
                    const headers = {
                        "Authorization": `Bearer ${token}`
                    };
                    const response = await customAxios.post(`${baseUrl}/api/${entity}`, data,  {headers});
                    const responseData = response.data;
                    return responseData;
                } catch (error) {
                    return null;
                }
            }
        );
    }

    function getAllCommunicationModes() {
        return createAsyncThunk(
            `${name}/getAllCommunicationModes`,
            async function (args, { getState }) {
                try {
                    const token = getState().auth.value;
                    const headers = {
                        "Authorization": `Bearer ${token}`
                    };
                    const response = await customAxios.get(`${baseUrl}/api/communication_modes`,  {headers});
                    //const token = response.token;
                    const responseData = response.data;
                    // set auth user in redux state
                    return responseData;
                } catch (error) {
                    return [];
                }
            }
        );
    }

    function getAllInquiryTypes() {
        return createAsyncThunk(
            `${name}/getAllInquiryTypes`,
            async function (args, { getState }) {
                try {
                    // const token = getState().auth.value;
                    // const headers = {
                    //     "Authorization": `Bearer ${token}`
                    // };
                    //const response = await customAxios.get(`${baseUrl}/api/inquiry_types`,  {headers});
                    //const responseData = response.data;
                    const responseData = [
                        {id: 1, name: "New Request"},
                        {id: 2, name: "Additional Data"},
                        {id: 3, name: "Clarification"},
                        {id: 4, name: "Escalation"},
                        {id: 5, name: "Demo"},
                        {id: 6, name: "Support"},
                        {id: 7, name: "Other"}
                    ];

                    return responseData;
                } catch (error) {
                    return [];
                }
            }
        );
    }

}

function createExtraReducers() {
    return (builder) => {
        getNewEntity();
        getAllCommunicationModes();
        getAllInquiryTypes();

        function getNewEntity() {
            var { pending, fulfilled, rejected } = extraActions.getNewEntity;
            builder
                .addCase(pending, (state) => {
                    state.item = { loading: true };
                })
                .addCase(fulfilled, (state, action) => {
                    state.item = { value: action.payload };
                })
                .addCase(rejected, (state, action) => {
                    state.item = { error: action.error };
                });
        }

        function getAllCommunicationModes() {
            var { pending, fulfilled, rejected } = extraActions.getAllCommunicationModes;
            builder
                .addCase(pending, (state) => {
                    state.communication_modes = { loading: true };
                })
                .addCase(fulfilled, (state, action) => {
                    state.communication_modes = { value: action.payload };
                    //alert('Payload: '+JSON.stringify(action.payload));
                })
                .addCase(rejected, (state, action) => {
                    state.communication_modes = { error: action.error };
                });
        }

        function getAllInquiryTypes() {
            var { pending, fulfilled, rejected } = extraActions.getAllInquiryTypes;
            builder
                .addCase(pending, (state) => {
                    state.inquiryTypes = { loading: true };
                })
                .addCase(fulfilled, (state, action) => {
                    state.inquiryTypes = { value: action.payload };
                    //alert('Payload: '+JSON.stringify(action.payload));
                })
                .addCase(rejected, (state, action) => {
                    state.inquiryTypes = { error: action.error };
                });
        }

    };

}